<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="LBLBASEINFO" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline>
                <c-qr-btn v-if="editable && tbmData.tbmId" :mobileUrl="'/sai/tbm/tbm?tbmId=' + tbmData.tbmId">
                  <!-- <template slot="detail">
                    <p>
                      <b>{{'-TBM명 : '}}</b>
                      {{tbmData.tbmName}}
                      <br>
                      <b>{{'-작업일 : '}}</b>
                      {{tbmData.tbmWorkDate }}
                    </p>
                  </template> -->
                </c-qr-btn>
                <!-- v-show="disabled" -->
                <c-btn v-show="tbmData.tbmId" label="출력" icon="print" @btnClicked="printTbm" />
                <c-btn v-show="editable && !tbmData.tbmId" label="타 TBM 불러오기" icon="save_alt" @btnClicked="copyTbm" />
                <c-btn v-show="editable && tbmData.tbmId && !disabled" label="LBLREMOVE" :editable="editable" icon="delete_forever" @btnClicked="remove" />
                <c-btn v-show="editable && !disabled" :url="saveUrl" :isSubmit="isSave" :param="tbmData" :mappingType="saveType" label="LBLSAVE" icon="save" @beforeAction="saveTbm" @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-text :editable="editable" :disabled="true" label="TBM번호" name="tbmNo" v-model="tbmData.tbmNo"> </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-text required :editable="editable" :disabled="disabled" label="TBM명" name="tbmName" v-model="tbmData.tbmName"> </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-work-permit :editable="editable" :disabled="disabled" label="작업허가번호" name="sopWorkPermitId" v-model="tbmData.sopWorkPermitId" @dataChange="dataChange" @remove="removeWorkPermit"> </c-work-permit>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <!-- required -->
                <c-vendor :editable="editable" :disabled="disabled" :haveProcess="true" :selfFlag="false" label="업체" name="vendorCd" v-model="tbmData.vendorCd" />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <!-- required -->
                <c-dept :editable="editable" :disabled="disabled" label="부서" name="deptCd" v-model="tbmData.deptCd" />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-datepicker required :editable="editable" :disabled="disabled" label="작업일" type="date" name="tbmWorkDate" v-model="tbmData.tbmWorkDate"> </c-datepicker>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <!-- required -->
                <c-process :editable="editable" :disabled="disabled" label="LBLPROCESS" name="processCd" v-model="tbmData.processCd"> </c-process>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!-- required -->
                <c-text :editable="editable" :disabled="disabled" label="LBLJOB" name="sopName" v-model="tbmData.sopName"> </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-field type="dept_user" :editable="editable" :disabled="disabled" label="작업책임자" name="tbmWorkResponsibleId" v-model="tbmData.tbmWorkResponsibleId"> </c-field>
              </div>
              <!-- 관련공사 -->
              <!-- <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-construnction
                  :disabled="disabled"
                  :editable="editable"
                  name="sopConstructionId"
                  v-model="tbmData.sopConstructionId">
                </c-construnction>
              </div> -->
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-plant required :editable="editable" :disabled="disabled" type="edit" name="plantCd" v-model="tbmData.plantCd" />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-checkbox :disabled="disabled" :editable="editable" :isArray="false" codeGroupCd="TBM_PRE_INSPECTION_CD" itemText="codeName" itemValue="code" label="사전점검" name="preInspections" v-model="tbmData.preInspections"> </c-checkbox>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-textarea :editable="editable" :disabled="disabled" label="작업내용" :rows="2" name="tbmWorkContents" v-model="tbmData.tbmWorkContents"> </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-textarea :editable="editable" :disabled="disabled" label="특이사항" :rows="2" name="significant" v-model="tbmData.significant"> </c-textarea>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
          <c-table ref="riskTable" title="위험요인 목록" :columns="riskGrid.columns" :gridHeight="riskGrid.height" :data="tbmData.tbmRiskHazardList" :filtering="false" :columnSetting="false" :usePaging="false" noDataLabel="위험요인을 추가하세요." :hideBottom="true" :editable="editable && !disabled" rowKey="tbmRiskId" selection="multiple">
            <template slot="table-button">
              <q-btn-group outline>
                <c-btn v-if="editable && !disabled" :showLoading="false" label="LBLADDDIRECTLY" icon="add" @btnClicked="addRisk" />
                <c-btn v-if="editable && !disabled && tbmData.tbmRiskHazardList.length > 0" :showLoading="false" label="LBLEXCEPT" icon="remove" @btnClicked="removeRisk" />
              </q-btn-group>
            </template>
          </c-table>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-table ref="equipTable" title="장비현황 목록" :columns="equipGrid.columns" :gridHeight="equipGrid.height" :data="tbmData.tbmEquipList" :filtering="false" :columnSetting="false" :usePaging="false" noDataLabel="장비현황을 추가하세요." :hideBottom="true" :editable="editable && !disabled" rowKey="tbmEquipId" selection="multiple">
            <template slot="table-button">
              <q-btn-group outline>
                <c-btn v-if="editable && !disabled" :showLoading="false" label="LBLADDDIRECTLY" icon="add" @btnClicked="addEquip" />
                <c-btn v-if="editable && !disabled && tbmData.tbmEquipList.length > 0" :showLoading="false" label="LBLEXCEPT" icon="remove" @btnClicked="removeEquip" />
              </q-btn-group>
            </template>
          </c-table>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
          <c-table ref="attendeeTable" title="참석자 및 건강상태 목록" :columns="attendeeGrid.columns" :gridHeight="attendeeGrid.height" :data="tbmData.tbmAttendeeList" :filtering="false" :columnSetting="false" :usePaging="false" noDataLabel="참석자가 없습니다." :hideBottom="true" :editable="editable && !disabled" selection="multiple" rowKey="tbmAttendeeId">
            <template slot="table-button">
              <q-btn-group outline>
                <c-btn v-if="editable && !disabled" :showLoading="false" label="추가(업체 근무자)" icon="add" @btnClicked="addAttendee1" />
                <c-btn v-if="editable && !disabled" :showLoading="false" label="추가(현업)" icon="add" @btnClicked="addAttendee2" />
                <c-btn v-if="editable && !disabled && tbmData.tbmAttendeeList.length > 0" :showLoading="false" label="LBLEXCEPT" icon="remove" @btnClicked="removeAttendee" />
              </q-btn-group>
            </template>
            <template v-slot:customArea="{ props, col }">
              <!-- <template v-if="col.name ==='tbmAttendeeUserName'">
                <c-text-column
                  v-if="props.row['tbmDirectFlag'] === 'Y'"
                  :editable="editable"
                  :props="props"
                  :col="col"
                  :disabled="disabled"
                  v-model="props.row['tbmAttendeeUserName']"
                  @datachange="datachange(props)"
                />
                <span v-else>
                  {{props.row['tbmAttendeeUserName']}}
                </span>
              </template>
              <template v-if="col.name ==='tbmAttendeeJobName'">
                <c-text-column
                  v-if="props.row['tbmDirectFlag'] === 'Y'"
                  :editable="editable"
                  :props="props"
                  :col="col"
                  :disabled="disabled"
                  v-model="props.row['tbmAttendeeJobName']"
                  @datachange="datachange(props)"
                />
                <span v-else>
                  {{props.row['tbmAttendeeJobName']}}
                </span>
              </template> -->
              <template v-if="col.name === 'click' && props.row['tbmDirectFlag'] !== 'Y'">
                <q-btn
                  round
                  unelevated
                  size="10px"
                  color="amber"
                  icon="mode"
                  @click.stop="
                    () => {
                      (rowIndex = props.rowIndex), (electronSignature = props.row.electronSignature);
                    }
                  "
                >
                  <q-popup-proxy :ref="'proxy_' + props.rowIndex" :breakpoint="400">
                    <component :is="col.component" :outFlag="true" :popupParam="props.row" :data="tbmData" :rowIndex="props.rowIndex" @callback="callback" />
                  </q-popup-proxy>
                </q-btn>
              </template>
            </template>
          </c-table>
        </div>
        <div class="col-4">
          <c-upload style="padding-top: 20px" :attachInfo="attachInfo" :editable="editable && !disabled" label="교육자료"> </c-upload>
        </div>
      </div>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'tbm-detail',
  props: {
    popupParam: {
      type: Object,
      default() {
        return {
          tbmId: '',
        };
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'TBM_EDUCATION',
        taskKey: '',
        beforeTaskKey: '',
      },
      tbmData: {
        befTbmId: '',
        tbmId: '',
        tbmNo: '',
        plantCd: '',
        permitNo: '',
        mdmSopId: '',
        sopName: '',
        sopMapId: '',
        mapName: '',
        tbmWorkResponsibleId: '',
        tbmWorkResponsibleName: '',
        tbmName: '',
        tbmWorkDate: '',
        tbmWorkArea: '',
        tbmWorkContents: '',
        significant: '',
        tbmCompleteFlag: 'N',
        processCd: '',
        vendorCd: '',
        deptCd: '',
        sopWorkPermitId: '',
        preInspections: '',
        tbmWorkPermitFlag: 'N',
        sopConstructionId: '',

        tbmAttendeeList: [],
        tbmRiskHazardList: [],
        tbmEquipList: [],

        deleteTbmAttendeeList: [],
        deleteTbmRiskHazardList: [],
        deleteTbmEquipList: [],
      },
      riskGrid: {
        columns: [
          {
            name: 'tbmJobStep',
            field: 'tbmJobStep',
            label: '작업단계',
            align: 'left',
            style: 'width:30%',
            type: 'text',
            sortable: false,
          },
          {
            name: 'tbmRiskHazard',
            field: 'tbmRiskHazard',
            label: '위험요인',
            align: 'left',
            style: 'width:30%',
            type: 'text',
            sortable: false,
          },
          {
            name: 'tbmImprovementMeasures',
            field: 'tbmImprovementMeasures',
            label: '안전대책',
            type: 'text',
            style: 'width:30%',
            align: 'left',
            sortable: false,
          },
          {
            name: 'tbmRiskType',
            field: 'tbmRiskType',
            label: '구분',
            style: 'width:10%',
            align: 'left',
            sortable: false,
          },
        ],
        height: '250px',
        data: [],
      },
      attendeeGrid: {
        columns: [
          {
            name: 'belongName',
            field: 'belongName',
            label: '소속',
            style: 'width:150px',
            // type: 'custom',
            align: 'center',
            sortable: false,
          },
          {
            name: 'tbmAttendeeUserName',
            field: 'tbmAttendeeUserName',
            label: '참석자',
            style: 'width:120px',
            // type: 'custom',
            align: 'center',
            sortable: false,
          },
          {
            name: 'tbmAttendeeJobName',
            field: 'tbmAttendeeJobName',
            label: 'LBLPOSITION',
            style: 'width:90px',
            // type: 'custom',
            align: 'center',
            sortable: false,
          },
          {
            name: 'mentalFatigueFlag',
            field: 'mentalFatigueFlag',
            label: '정신적<br>피로',
            style: 'width:50px',
            align: 'center',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: false,
          },
          {
            name: 'mentalPhychologicalFlag',
            field: 'mentalPhychologicalFlag',
            label: '심리적<br>피로',
            style: 'width:50px',
            align: 'center',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: false,
          },
          {
            name: 'mentalPhysicalFlag',
            field: 'mentalPhysicalFlag',
            label: '육체적<br>피로',
            style: 'width:50px',
            align: 'center',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: false,
          },
          {
            name: 'physicalDefectFlag',
            field: 'physicalDefectFlag',
            label: '신체적<br>결함',
            style: 'width:50px',
            align: 'center',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: false,
          },
          {
            name: 'healthStatusCd',
            field: 'healthStatusCd',
            label: '건강상태',
            type: 'select',
            setHeader: true,
            style: 'width:90px',
            align: 'center',
            codeGroupCd: 'TBM_HEALTH_STATUS_CD',
            sortable: false,
          },
          {
            name: 'click',
            field: 'click',
            label: '서명<br>',
            style: 'width:60px',
            type: 'custom',
            align: 'center',
            sortable: false,
            component: () => import(`${'./signaturePop.vue'}`),
          },
          {
            name: 'remark',
            field: 'remark',
            label: 'LBLREMARK',
            type: 'textarea',
            style: 'width:200px',
            align: 'left',
            sortable: false,
          },
        ],
        height: '300px',
        data: [],
      },
      equipGrid: {
        columns: [
          {
            name: 'equipName',
            field: 'equipName',
            label: '장비명',
            align: 'left',
            style: 'width:80%',
            type: 'text',
            sortable: false,
          },
          {
            name: 'equipAmount',
            field: 'equipAmount',
            label: '수량',
            align: 'right',
            style: 'width:20%',
            type: 'number',
            sortable: false,
          },
        ],
        height: '250px',
        data: [],
      },
      getUrl: '',
      saveUrl: '',
      completeUrl: '',
      deleteUrl: '',
      updateUrl: '',
      printUrl: '',
      getWorkPermitUrl: '',
      saveType: 'POST',
      isSave: false,
      isComplete: false,
      isEdit: false,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        // isFull: true,
        top: '',
        param: {},
        closeCallback: null,
      },
      editable: false,
      isApproval: false,
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    disabled() {
      return this.tbmData.tbmCompleteFlag === 'Y' || this.tbmData.approvalStatusCd === 'ASC0000001';
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getWorkPermitUrl = selectConfig.sop.swp.workPermit.get.url;
      this.getUrl = selectConfig.sai.tbm.get.url;
      this.saveUrl = transactionConfig.sai.tbm.insert.url;
      this.insertUrl = transactionConfig.sai.tbm.insert.url;
      this.updateUrl = transactionConfig.sai.tbm.update.url;
      this.deleteUrl = transactionConfig.sai.tbm.delete.url;
      this.completeUrl = transactionConfig.sai.tbm.complete.url;
      this.printUrl = selectConfig.sai.tbm.print.url;

      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.tbmId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.tbmId);
        this.$http.type = 'GET';
        this.$http.request(_result => {
          this.tbmData = this.$_.clone(_result.data);
          // 상세팝업 최초작성/최근수정 정보 노출
          this.$emit('setRegInfo', _result.data);
          this.$set(this.attachInfo, 'taskKey', this.popupParam.tbmId);
        });
      } else {
        this.tbmData.tbmWorkDate = this.$comm.getToday();
        this.tbmData.tbmWorkResponsibleId = this.$store.getters.user.userId;
      }
    },
    saveTbm() {
      if (this.tbmData.tbmId) {
        this.saveUrl = this.updateUrl;
        this.saveType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.saveType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.tbmData.regUserId = this.$store.getters.user.userId;
              this.tbmData.chgUserId = this.$store.getters.user.userId;
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.tbmId = _result.data;
      if (this.saveType === 'POST') {
        this.$set(this.attachInfo, 'isSubmit', uid());
      }
      this.$set(this.attachInfo, 'taskKey', _result.data);
      this.getDetail();
    },
    addRisk() {
      this.tbmData.tbmRiskHazardList.push({
        tbmId: this.tbmData.tbmId,
        tbmRiskId: uid(),
        regUserId: this.$store.getters.user.userId,
        editFlag: 'C',
        tbmDirectFlag: 'Y',
        tbmPermitFlag: 'N',
        tbmRiskType: '직접추가',
      });
    },
    removeRisk() {
      let selectData = this.$refs['riskTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          if (!this.tbmData.deleteTbmRiskHazardList) {
            this.tbmData.deleteTbmRiskHazardList = [];
          }
          if (
            this.$_.findIndex(this.tbmData.deleteTbmRiskHazardList, {
              tbmRiskId: item.tbmRiskId,
            }) === -1 &&
            item.editFlag !== 'C'
          ) {
            this.tbmData.deleteTbmRiskHazardList.push(item);
          }
          this.tbmData.tbmRiskHazardList = this.$_.reject(this.tbmData.tbmRiskHazardList, item);
        });
      }
    },
    addEquip() {
      this.tbmData.tbmEquipList.splice(0, 0, {
        tbmId: this.tbmData.tbmId,
        tbmEquipId: uid(),
        equipName: '',
        equipAmount: 0,
        regUserId: this.$store.getters.user.userId,
        editFlag: 'C',
      });
    },
    removeEquip() {
      let selectData = this.$refs['equipTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          if (!this.tbmData.deleteTbmEquipList) {
            this.tbmData.deleteTbmEquipList = [];
          }
          if (
            this.$_.findIndex(this.tbmData.deleteTbmEquipList, {
              tbmEquipId: item.tbmEquipId,
            }) === -1 &&
            item.editFlag !== 'C'
          ) {
            this.tbmData.deleteTbmEquipList.push(item);
          }
          this.tbmData.tbmEquipList = this.$_.reject(this.tbmData.tbmEquipList, item);
        });
      }
    },
    // TBM 참석자 선택
    addAttendee1() {
      this.popupOptions.title = '업체 근무자 검색'; // 업체 근무자 검색
      this.popupOptions.param = {
        type: 'multiple',
        plantCd: this.tbmData.plantCd,
        vendorCd: this.tbmData.vendorCd, // 수급업체코드
      };
      this.popupOptions.target = () => import(`${'@/pages/common/vendor/vendorUserPop.vue'}`);
      this.popupOptions.width = '70%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeUserPopup1;
    },
    closeUserPopup1(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          let index = this.$_.findIndex(this.tbmData.tbmAttendeeList, {
            tbmAttendeeUserId: _item.userId,
          });
          if (index === -1) {
            this.tbmData.tbmAttendeeList.push({
              tbmId: this.popupParam.tbmId,
              tbmAttendeeId: uid(),
              belongName: '(업체) ' + _item.vendorName, // 소속명
              vendorCd: _item.vendorCd,
              tbmAttendeeUserId: '',
              tbmAttendeeUserName: _item.personName,
              tbmAttendeeJobName: _item.jobName,
              healthStatusCd: 'THS0000001',
              mentalFatigueFlag: 'N',
              mentalPhychologicalFlag: 'N',
              mentalPhysicalFlag: 'N',
              physicalDefectFlag: 'N',
              tbmDirectFlag: 'Y',
              electronSignature: '',
              remark: '',
              regUserId: this.$store.getters.user.userId,
              editFlag: 'C',
            });
          }
        });
      }
    },
    addAttendee2() {
      this.popupOptions.title = 'TBM 참석자 검색'; // TBM 참석자 검색
      this.popupOptions.param = {
        type: 'multiple',
        plantCd: this.tbmData.plantCd,
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.width = '70%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeUserPopup2;
    },
    closeUserPopup2(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          let index = this.$_.findIndex(this.tbmData.tbmAttendeeList, {
            tbmAttendeeUserId: _item.userId,
          });
          if (index === -1) {
            this.tbmData.tbmAttendeeList.push({
              tbmId: this.popupParam.tbmId,
              tbmAttendeeId: uid(),
              belongName: '(현업) ' + _item.deptName, // 소속명
              tbmAttendeeUserId: _item.userId,
              tbmAttendeeUserName: _item.userName,
              tbmAttendeeJobName: _item.jobName,
              healthStatusCd: 'THS0000001',
              mentalFatigueFlag: 'N',
              mentalPhychologicalFlag: 'N',
              mentalPhysicalFlag: 'N',
              physicalDefectFlag: 'N',
              tbmDirectFlag: 'N',
              electronSignature: '',
              remark: '',
              regUserId: this.$store.getters.user.userId,
              editFlag: 'C',
            });
          }
        });
      }
    },
    // addAttendee2() {
    //   // 참석자 직접추가
    //   this.tbmData.tbmAttendeeList.push({
    //     tbmId: this.popupParam.tbmId,
    //     tbmAttendeeId: uid(),
    //     tbmAttendeeUserId: "",
    //     tbmAttendeeUserName: "",
    //     tbmAttendeeJobName: "",
    //     healthStatusCd: "THS0000001",
    //     mentalFatigueFlag: "N",
    //     mentalPhychologicalFlag: "N",
    //     mentalPhysicalFlag: "N",
    //     physicalDefectFlag: "N",
    //     electronSignature: '',
    //     tbmDirectFlag: 'Y',
    //     remark: "",
    //     regUserId: this.$store.getters.user.userId,
    //     editFlag: "C",
    //   });
    // },
    removeAttendee() {
      let selectData = this.$refs['attendeeTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          if (!this.tbmData.deleteTbmAttendeeList) {
            this.tbmData.deleteTbmAttendeeList = [];
          }
          if (
            this.$_.findIndex(this.tbmData.deleteTbmAttendeeList, {
              tbmAttendeeId: item.tbmAttendeeId,
            }) === -1 &&
            item.editFlag !== 'C'
          ) {
            this.tbmData.deleteTbmAttendeeList.push(item);
          }
          this.tbmData.tbmAttendeeList = this.$_.reject(this.tbmData.tbmAttendeeList, item);
        });
      }
    },
    copyTbm() {
      this.popupOptions.title = '타 TBM 검색'; 
      this.popupOptions.param = {
        type: 'single',
      };
      this.popupOptions.target = () => import(`${'./tbmPop.vue'}`);
      this.popupOptions.width = '70%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeCopyTbmPopup;
    },
    closeCopyTbmPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.tbmData.tbmRiskHazardList = [];
      if (data && data.length > 0) {
        if (data[0].tbmId) {
          this.$http.url = this.$format(this.getUrl, data[0].tbmId);
          this.$http.type = 'GET';
          this.$http.request(_result => {
            this.tbmData.plantCd = _result.data.plantCd;
            this.tbmData.permitNo = _result.data.permitNo;
            this.tbmData.mdmSopId = _result.data.mdmSopId;
            this.tbmData.sopName = _result.data.sopName;
            this.tbmData.sopMapId = _result.data.sopMapId;
            this.tbmData.tbmName = _result.data.tbmName;
            this.tbmData.tbmWorkResponsibleId = _result.data.tbmWorkResponsibleId;
            this.tbmData.tbmWorkResponsibleName = _result.data.tbmWorkResponsibleName;
            this.tbmData.tbmWorkDate = this.$comm.getToday();
            this.tbmData.tbmWorkArea = _result.data.tbmWorkArea;
            this.tbmData.tbmWorkContents = _result.data.tbmWorkContents;
            this.tbmData.tbmCompleteFlag = 'N';
            this.tbmData.processCd = _result.data.processCd;
            this.tbmData.vendorCd = _result.data.vendorCd;
            this.tbmData.sopWorkPermitId = _result.data.sopWorkPermitId;
            this.tbmData.preInspections = _result.data.preInspections;
            this.tbmData.tbmAttendeeList = _result.data.tbmAttendeeList;
            this.tbmData.tbmRiskHazardList = _result.data.tbmRiskHazardList;
            this.tbmData.tbmHazardEquipModelList = _result.data.tbmHazardEquipModelList;
            this.tbmData.tbmEquipList = _result.data.tbmEquipList;
            this.tbmData.befTbmId = data[0].tbmId;

            this.$http.url = this.insertUrl;
            this.$http.type = 'POST';
            this.$http.param = this.tbmData;
            this.$http.request(_result => {
              this.popupParam.tbmId = _result.data;
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.getDetail();
            });
          });
        }
      }
    },
    printTbm() {
      let thisVue = this;
      this.$http.url = this.$format(this.printUrl, this.tbmData.tbmId);
      this.$http.type = 'GET';
      this.$http.request(
        _result => {
          let fileOrgNm = this.tbmData.tbmNo + '.docx';
          let blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        },
        () => {}
      );
    },
    dataChange(data) {
      if (data) {
        // this.tbmData.tbmAttendeeList = [];
        this.$http.url = this.$format(this.getWorkPermitUrl, data.sopWorkPermitId);
        this.$http.type = 'GET';
        this.$http.request(_result => {
          this.tbmData.sopWorkPermitId = _result.data.sopWorkPermitId;
          this.tbmData.permitNo = _result.data.permitNo; // 허가번호
          // if (!this.tbmData.tbmWorkDate) this.tbmData.tbmWorkDate = _result.data.permitDate; // 작업일
          if (!this.tbmData.processCd) this.tbmData.processCd = _result.data.processCd; // 공정
          if (!this.tbmData.vendorCd) this.tbmData.vendorCd = _result.data.vendorCd; // 업체
          this.tbmData.mdmSopId = _result.data.mdmSopId; // 작업
          this.tbmData.sopMapId = _result.data.sopMapId; // 작업장소
          // if (!this.tbmData.tbmWorkResponsibleId || this.tbmData.tbmWorkResponsibleId === '') this.tbmData.tbmWorkResponsibleId = _result.data.maintenanceDeptCheckUserId; // 책임자
          this.tbmData.sopName = _result.data.sopName; // 작업
          if (!this.tbmData.tbmName) this.tbmData.tbmName = _result.data.sopName; // TBM명
          if (!this.tbmData.tbmWorkContents) this.tbmData.tbmWorkContents = _result.data.workSummary; // 작업내용
          this.tbmData.tbmWorkPermitFlag = 'Y';

          // 새로 불러오기 위해 위험요소 리스트를 제거대상리스트에 다 넣는다
          // if (!this.tbmData.deleteTbmRiskHazardList) this.tbmData.deleteTbmRiskHazardList = [];
          // this.tbmData.tbmRiskHazardList.forEach(item => {
          //   if (
          //     this.tbmData.deleteTbmRiskHazardList.findIndex({
          //       tbmRiskId: item.tbmRiskId,
          //     }) === -1 &&
          //     item.editFlag !== 'C'
          //   ) {
          //     this.tbmData.deleteTbmRiskHazardList.push(item);
          //   }
          // });
          // this.tbmData.tbmRiskHazardList = [];
          if (_result.data.assessments && _result.data.assessments.length > 0) {
            _result.data.assessments.forEach(_item => {
              if (!_item.riskHazardName) return;
              this.tbmData.tbmRiskHazardList.push({
                tbmId: this.tbmData.tbmId || uid(),
                tbmRiskId: uid(),
                tbmJobStep: _item.jobStepName,
                tbmRiskHazard: _item.riskHazardName,
                tbmImprovementMeasures: _item.safetyActionMeasures,
                tbmDirectFlag: 'N',
                tbmPermitFlag: 'Y',
                tbmRiskType: '작업허가서',
                regUserId: this.$store.getters.user.userId,
                editFlag: 'C',
              });
            });
          }
        });
      }
    },
    removeWorkPermit() {
      this.tbmData.sopWorkPermitId = '';
      this.tbmData.permitNo = '';
      this.tbmData.processCd = '';
      this.tbmData.mdmSopId = '';
      this.tbmData.sopName = '';
      this.tbmData.vendorCd = '';
      this.tbmData.vendorName = '';
      this.tbmData.tbmWorkDate = '';
      this.tbmData.tbmWorkResponsibleId = '';
      this.tbmData.tbmWorkResponsibleName = '';
      this.tbmData.mapName = '';
      this.tbmData.sopMapId = '';
      this.tbmData.tbmWorkContents = '';
    },
    remove() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.tbmData.tbmId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          });
        },
        // 취소 callback 함수
        cancelCallback: () => {},
      });
    },
    datachange(props) {
      if (props.row['editFlag'] !== 'C') {
        props.row['editFlag'] = 'U';
        props.row['chgUserId'] = this.$store.getters.user.userId;
      }
    },
    callback(data, rowIndex) {
      this.tbmData.tbmAttendeeList[rowIndex].electronSignature = data;
      this.tbmData.tbmAttendeeList[rowIndex].eduAttendFlag = 'Y';
      if (this.tbmData.tbmAttendeeList[rowIndex].editFlag !== 'C') {
        this.tbmData.tbmAttendeeList[rowIndex].editFlag = 'U';
      }
      let refName = 'proxy_' + rowIndex;
      this.$refs[refName].hide();
    },
  },
};
</script>
